import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";

export default function RegisterPage() {
  const { register, formatApiError } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const redirect = params.get("redirect") || "/";
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(name, email, password);
      toast.success("Welcome to Kesher.");
      navigate(redirect);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Sign up failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="container-editorial mt-14">
      <div className="grid grid-cols-12 gap-8">
        <div className="col-span-12 md:col-span-6 md:col-start-4">
          <p className="label-uppercase text-[#B24C38]">Join the marketplace</p>
          <h1 className="font-serif text-5xl md:text-6xl tracking-tighter mt-3">Create an Account</h1>
          <form onSubmit={submit} className="mt-10 space-y-6">
            <div>
              <label className="label-uppercase block mb-2">Name</label>
              <Input data-testid="register-name" required value={name} onChange={e => setName(e.target.value)}
                     className="rounded-none border-[#111] bg-transparent h-12"/>
            </div>
            <div>
              <label className="label-uppercase block mb-2">Email</label>
              <Input data-testid="register-email" type="email" required value={email} onChange={e => setEmail(e.target.value)}
                     className="rounded-none border-[#111] bg-transparent h-12"/>
            </div>
            <div>
              <label className="label-uppercase block mb-2">Password</label>
              <Input data-testid="register-password" type="password" required minLength={6} value={password} onChange={e => setPassword(e.target.value)}
                     className="rounded-none border-[#111] bg-transparent h-12"/>
              <p className="text-xs text-[#4A4A4A] mt-1">At least 6 characters.</p>
            </div>
            <button type="submit" disabled={loading} className="btn-terracotta w-full justify-center" data-testid="register-submit">
              {loading ? "Creating..." : "Create Account →"}
            </button>
            <p className="text-sm text-[#4A4A4A]">
              Have an account? <Link to={`/login?redirect=${encodeURIComponent(redirect)}`} className="link-underline text-[#111]">Sign in</Link>
            </p>
          </form>
        </div>
      </div>
    </div>
  );
}
